<template>
  <BaseModal
    @close="close"
    @commit="commit"
    :lang="lang"
    :showLogo="false"
    class="modal-sendbp"
  >
    <div class="modal-sendbp-container" :style="styleModal">
      <Close class="modal-sendbp-close" @click="close"></Close>
      <input class="invisible" type="file" accept="*/*" multiple id="upload-files" @change="addTempAtts">
      <div slot="header" class="modal-sendbp-header">
        <!-- <div class="modal-sendbp-header-desc" @click="showDesc=true" v-if="!showDesc">
          <div class="modal-sendbp-header-desc-text">投递说明</div>
          <div class="modal-sendbp-header-desc-arrow"></div>
        </div> -->
        <!-- <Flow123 class="modal-sendbp-header-flow" :step="step_"></Flow123> -->
        <div v-if="step_===1" class="step1-tab">
          <div class="step1-tab-nutsbp" :class="step1Tab===0?'active':''"
            @click="step1Tab=0"
          >上传疯狂BP</div>
          <div class="step1-tab-local" :class="step1Tab===1?'active':''"
            @click="step1Tab=1"
          >本地上传</div>
        </div>
      </div>
      <div slot="body" class="modal-sendbp-body">
        <div v-if="step_===1" class="modal-sendbp-body-step1">
          <div v-if="step1Tab===0">
            <div v-if="list.length<=0">
              <div class="modal-sendbp-body-step1-no-bg"></div>
              <div class="modal-sendbp-body-step1-no-text">
                <div>目前暂无BP</div>
                <div>请去挑选模板创建吧</div>
              </div>
            </div>
            <div v-if="list.length>0" class="modal-sendbp-body-select">
              <div v-for="(row, i) in list" :key="i" class="modal-sendbp-body-select-item">
                <Avatar username="avatar" :src="row.index_thumbnail_url" :size="50" :rounded="false" class="modal-sendbp-body-select-item-img"></Avatar>
                <div class="modal-sendbp-body-select-item-desc">
                  <div class="modal-sendbp-body-select-item-desc-title">{{row.name ? row.name : '请输入项目名称'}}</div>
                  <div class="modal-sendbp-body-select-item-desc-time">{{row.update_time | date}}</div>
                </div>
                <div class="modal-sendbp-body-select-item-check">
                  <input type="checkbox"
                    :true-value="i"
                    :false-value="null"
                    v-model.trim="selectedIndex" />
                </div>
              </div>
            </div>
          </div>
          <div v-if="step1Tab===1" class="modal-sendbp-body-select-local">
            <div class="modal-sendbp-body-select-upload-btn"
              @click="emitUpload">上传附件</div>
            <div class="modal-sendbp-body-select-upload-area">
              <div v-for="(file, i) in temp.attachments" :key="i" class="modal-sendbp-body-select-upload-item">
                <div class="left">
                  <div class="name">{{file.name}}</div>
                </div>
                <div class="right">
                  <span class="size">{{file.size | size}}</span>
                  <i v-if="!file.uploaded" class="icon fa fa-spin fa-spinner" aria-hidden="true"></i>
                  <i
                    v-if="file.uploaded"
                    class="icon icon-pr_phone_icon_preference_delete red"
                    @click="deleteTempAtt(file, i)"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step_===2" class="modal-sendbp-body-step2">
          <div class="modal-sendbp-body-title">项目资料</div>
          <div class="modal-sendbp-body-block">
            <div class="modal-sendbp-body-block-title">
              <span class="modal-sendbp-body-block-title-star">*</span>
              <span>{{lang.p_name}}</span>
            </div>
            <div class="modal-sendbp-body-block-input">
              <BaseInput v-model.trim="input.p_name" :placeholder="`请输入${lang.p_name}`" width="258px" height="36px"></BaseInput>
            </div>
          </div>
          <div class="modal-sendbp-body-block">
            <div class="modal-sendbp-body-block-title">
              <!-- <span class="modal-sendbp-body-block-title-star">*</span> -->
              <span>{{lang.desc}}</span>
            </div>
            <div class="modal-sendbp-body-block-textarea">
              <textarea v-model.trim="input.desc" placeholder="请大概描述一下您的项目"></textarea>
            </div>
          </div>
          <div class="modal-sendbp-body-title">{{lang.step2}}</div>
          <div class="modal-sendbp-body-block">
            <div class="modal-sendbp-body-block-title">
              <span class="modal-sendbp-body-block-title-star">*</span>
              <span>{{lang.username}}</span>
            </div>
            <div class="modal-sendbp-body-block-input">
              <BaseInput v-model.trim="input.username" :placeholder="`请输入${lang.username}`" width="258px" height="36px"></BaseInput>
            </div>
          </div>
          <div class="modal-sendbp-body-block">
            <div class="modal-sendbp-body-block-title">
              <span class="modal-sendbp-body-block-title-star">*</span>
              <span>{{lang.mobile}}</span>
            </div>
            <div class="modal-sendbp-body-block-input">
              <BaseInput v-model.trim="input.mobile" type="tel" :placeholder="`请输入${lang.mobile}`" width="258px" height="36px"></BaseInput>
            </div>
          </div>
          <div class="modal-sendbp-body-block">
            <div class="modal-sendbp-body-block-title">
              <span class="modal-sendbp-body-block-title-star">*</span>
              <span>{{lang.weixin}}</span>
            </div>
            <div class="modal-sendbp-body-block-input">
              <BaseInput v-model.trim="input.weixin" :placeholder="`请输入${lang.weixin}`" width="258px" height="36px"></BaseInput>
            </div>
          </div>
          <div class="modal-sendbp-body-block">
            <div class="modal-sendbp-body-block-title">
              <span class="modal-sendbp-body-block-title-star">*</span>
              <span>{{lang.email}}</span>
            </div>
            <div class="modal-sendbp-body-block-input">
              <BaseInput v-model.trim="input.email" :placeholder="`请输入${lang.email}`" width="258px" height="36px"></BaseInput>
            </div>
          </div>
        </div>
        <div v-if="step_===3" class="modal-sendbp-body-step3">
          <div class="title">{{lang.step3}}</div>
          <div class="q">
            <textarea v-model.trim="input.q" :placeholder="`请输入${lang.q}`"></textarea>
          </div>
          <div class="q-tip">
            <div>1、付费提问后，投资人一周内未给您回复，系统会将投递金退回到您的账户中</div>
            <div>2、向投资人免费投递，每个投资人仅一次</div>
            <div>3、付费投递后，投资人回复机会更高</div>
          </div>
        </div>
        <div v-if="step_===4" class="modal-sendbp-body-finish">
          <div>
            <div>完成付款后</div>
            <div>请根据您的情况点击下面的按钮</div>
          </div>
        </div>
        <div v-if="step_===5" class="modal-sendbp-body-success">
          <div class="text">您已投递成功</div>
        </div>
      </div>
      <div slot="footer" class="modal-sendbp-footer">
        <!-- left button -->
        <BaseButton3 v-if="step_<=1" class="modal-sendbp-footer-button" @click="close" :type="2">{{lang.cancel}}</BaseButton3>
        <BaseButton3 v-if="step_>1 && step_<3" class="modal-sendbp-footer-button" @click="prev" :type="2">{{lang.prev}}</BaseButton3>
        <BaseButton3 v-if="step_===3" class="modal-sendbp-footer-button" @click="pay('free')" :type="2" :disabled="disabledFree">{{langSendbpFree}}</BaseButton3>
        <BaseButton3 v-if="step_===4" class="modal-sendbp-footer-button" @click="repay" :type="2">{{lang.finish_cancel}}</BaseButton3>
        <!-- right button -->
        <!-- <BaseButton3 v-if="list.length<=0 && step_===1" class="modal-sendbp-footer-button" @click="create">{{lang.create}}</BaseButton3> -->
        <BaseButton3 v-if="step_<3" class="modal-sendbp-footer-button" @click="next">{{lang.next}}</BaseButton3>
        <BaseButton3 v-if="step_===3" class="modal-sendbp-footer-button" @click="pay">{{langPay}}</BaseButton3>
        <BaseButton3 v-if="step_===4" class="modal-sendbp-footer-button" @click="finish">{{lang.finish}}</BaseButton3>
        <BaseButton3 v-if="step_===5" class="modal-sendbp-footer-button" @click="close">{{lang.confirm}}</BaseButton3>
      </div>
      <div slot="right" v-if="showDesc" class="modal-sendbp-desc">
        <div class="modal-sendbp-desc-close" @click="showDesc=false">收起</div>
        <div class="modal-sendbp-desc-title">付费投递说明</div>
        <div class="modal-sendbp-desc-desc1">
          付费向投资人投递BP后，不仅有可能获得投资人亲自回复，更有可能促成投资机会。因此我们建议您简单介绍项目亮点，提出与项目有关的问题
        </div>
        <div class="modal-sendbp-desc-desc2">
          投资人回复后才会进行扣费；若投资人一周内未给您回复，系统会将投递金退回到您的账户中
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import _ from 'lodash'
import { format } from 'util'
import weui from 'weui.js'

import Avatar from 'vue-avatar'
import BaseModal from './BaseModal.vue'

import Flow123 from '../Flow123.vue'
import Close from '../Close.vue'
import {
  BaseButton3,
  BaseButton5
} from '../button'
import { BaseInput } from '../input'
export default {
  components: {
    Avatar,
    BaseModal,
    Flow123,
    Close,
    BaseButton3,
    BaseButton5,
    BaseInput
  },
  props: {
    step: { // init step
      type: Number,
      default: 1
    },
    lang: {
      type: Object,
      default () {
        return {
          title: '编辑基本信息',
          cancel: '取消',
          create: '创建',
          prev: '上一步',
          next: '下一步',
          step2: '个人资料',
          step3: '是否付费向投资人付费提问',
          username: '姓名',
          mobile: '手机号',
          weixin: '微信',
          email: '邮箱',
          p_name: '项目名称',
          desc: '项目简介',
          q: '您要请教的问题',
          upload: '上传附件',
          sendbp_free: '免费投递',
          pay: `付费投递（￥%s）`,
          finish: '付款成功',
          finish_cancel: '失败，重新支付',
          confirm: '确定'
        }
      }
    },
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      step1Tab: 0,
      cardInfo: null,
      showDesc: false,
      selectedIndex: null,
      step_: this.step,
      temp: {
        attachments: []
      },
      input: {
        attachments: [],
        username: '',
        mobile: '',
        email: '',
        weixin: '',
        p_name: '',
        desc: '',
        q: ''
      },
      list: [],
      timerId: null,
      isPolling: false,
      requiredAttrs: {
        step1: [],
        step2: [
          'p_name',
          // 'desc',
          'username',
          'mobile',
          'weixin',
          'email'
        ],
        step3: [
          'q'
        ]
      },
      freeCount: 0
    }
  },
  computed: {
    styleModal () {
      return `height:${this.height};width:${this.width};`
    },
    height () {
      if (this.step_ === 1) {
        return '537px'
      }
      if (this.step_ === 2) {
        return '600px'
      }
      if (this.step_ === 3) {
        return '571px'
      }
      return '300px'
    },
    width () {
      if (this.showDesc) {
        return '600px'
      }
      return '400px'
    },
    langPay () {
      return format(this.lang.pay, _.get(this.data, 'investor.deliverPrice') / 100)
    },
    disabledFree () {
      if (this.freeCount > 0) {
        return true
      }
      return false
    },
    langSendbpFree () {
      if (this.freeCount > 0) {
        return `已${this.lang.sendbp_free}`
      }
      return this.lang.sendbp_free
    }
  },
  methods: {
    tryOpenHomepage () {
      let auto = _.get(this.data, 'homepage.auto_open')
      // let auto = true
      if (auto) {
        let homepageUrl = _.get(this.data, 'homepage.url')
        // let homepageUrl = 'https://nutsbp.com'
        if (homepageUrl && homepageUrl !== '') {
          window.open(homepageUrl, '_blank')
        }
      }
    },
    close () {
      if (this.step_ === 5) { // 付款成功
        this.tryOpenHomepage()
      }
      this.clearTimer()
      this.$emit('close')
    },
    commit () { this.$emit('commit', this.input) },
    create () { this.$emit('create') },
    prev () {
      this.step_--
    },
    next () {
      switch (this.step_) {
        case 1:
          // if (this.selectedIndex === null) {
          //   return
          // }
          break
        case 2:
          for (let k of this.requiredAttrs.step2) {
            if (!this.input[k]) {
              return
            }
          }
          // 若是 瘋狂bp 資料是空白的則直接寫進去
          // @see https://github.com/nutspie/doc/blob/master/nutsbp/v2.0/user/:user_id.md#%E6%9B%B4%E6%96%B0%E4%B8%AA%E4%BA%BA%E8%B5%84%E8%AE%AF
          if (this.cardInfo !== null) {
            let params = {}
            if (!_.get(this.cardInfo, 'realname')) {
              params.realname = this.input.username
            }
            if (!_.get(this.cardInfo, 'phone')) {
              params.phone = this.input.mobile
            }
            if (!_.get(this.cardInfo, 'weixin')) {
              params.weixin = this.input.weixin
            }
            if (!_.get(this.cardInfo, 'email')) {
              params.email = this.input.email
            }
            if (Object.keys(params).length > 0) {
              this.$store.dispatch('api/nutsbp/updateMe', params)
            }
          }
          break
        case 3:
          for (let k of this.requiredAttrs.step3) {
            if (!this.input[k]) {
              return
            }
          }
          break
      }
      this.step_++
    },
    /**
     * 上传图片相关
     */
    emitUpload (event) {
      document.getElementById('upload-files').click()
    },
    checkAtt (oFile) {
      if (!oFile || !oFile.type) {
        throw new Error('请选择正确格式')
      }
      let mb = 10 * 2
      let iMaxFilesize = 1048576 * mb
      if (oFile.size > iMaxFilesize) {
        throw new Error(`请上传小于${mb}M的文件`)
      }
    },
    async addTempAtts (event) {
      for (let oFile of event.target.files) {
        try {
          this.checkAtt(oFile)
        } catch (e) {
          weui.toast(`${e.message}(${oFile.name})`)
          throw e
        }
      }

      let jobs = []
      for (let oFile of event.target.files) {
        jobs.push(this.addTempAtt(oFile))
      }
      await Promise.all(jobs)
    },
    async addTempAtt (file) {
      let length = this.temp.attachments.push(file)
      let i = length - 1
      try {
        let data = await this.$store.dispatch('api/ranch/upload', {file})
        if (Array.isArray(data)) {
          this.input.attachments[i] = data[0]
        } else {
          this.input.attachments[i] = data
        }

        file.uploaded = true
        // 強制刷新
        this.temp.attachments.splice(i, 1, file)
      } catch (e) {
        console.error('addTempAtt', 'e', e)

        // upload failed, remove it from temp list
        for (let i = 0; i < this.temp.attachments.length; i++) {
          if (this.temp.attachments[i] === file) {
            this.temp.attachments.splice(i, 1)
            break
          }
        }
      }
    },
    deleteTempAtt (row, i) {
      this.temp.attachments.splice(i, 1)
      if (this.input.attachments[i]) {
        this.input.attachments.splice(i, 1)
      }
    },
    clearTimer () {
      clearTimeout(this.timerId)
      this.timerId = null
      this.isPolling = false
    },
    startCheckListener (uuid) {
      if (this.isPolling) {
        return
      }
      if (this.timerId !== null) {
        return
      }
      this.isPolling = true
      let interval = 5000
      let fn = () => {
        this.timerId = setTimeout(async () => {
          let state = await this.getPayState(uuid)
          if (state === 1 || state === 2) {
            this.next()
          } else {
            fn()
          }
        }, interval)
      }
      fn()
    },
    async getPayState (uuid) {
      try {
        let data = await this.$store.dispatch('api/ranch/deliverFind', {
          id: uuid
        })
        return _.get(data, 'state')
      } catch (e) {
        return null
      }
    },
    async pay (buttonType) {
      for (let step of Object.keys(this.requiredAttrs)) {
        for (let k of this.requiredAttrs[step]) {
          if (!this.input[k]) {
            weui.toast(`${this.lang[k]}为必填项！`)
            return
          }
        }
      }
      // 寫入暫存
      let input = {}
      for (let k of this.requiredAttrs.step2) {
        input[k] = this.input[k]
      }
      this.$store.dispatch('set', {
        path: 'temp.SendBpModal.input',
        value: input
      })

      let el = null
      try {
        // create 訂單
        let params = {
          investor: _.get(this.data, 'uuid'),
          investorName: _.get(this.data, 'card.name'),
          investorAccount: _.get(this.data, 'account'),

          name: this.input.username,
          mobile: this.input.mobile,
          weixin: this.input.weixin,
          email: this.input.email,
          bpName: this.input.p_name,
          bpDesc: this.input.desc,
          memo: this.input.q,
          attachments: JSON.stringify(this.input.attachments)
        }
        if (this.selectedIndex !== null && this.selectedIndex > -1) {
          params.slideId = this.list[this.selectedIndex].slide_id
        }

        switch (buttonType) {
          case 'free': {
            let order = await this.$store.dispatch('api/ranch/deliverFree', params)
            console.log('pay', 'order', order)

            await this.$store.dispatch('api/dartcome/sendNutsbpToDartcome', {deliverId: order.id})
            this.next()
            this.next()
            break
          }
          case 'pay':
          default: {
            el = window.open('', '_blank') // 先打開，不然會被擋
            let order = await this.$store.dispatch('api/ranch/deliverCreate', params)
            console.log('pay', 'order', order)
            /**
             * @see https://github.com/nutspie/doc/blob/master/nutsbp/nutsbp-v3.md
             */
            let url = `${this.$store.getters.editorUrl}/bpBill/${order.id}?u=${this.$store.state.me.u}`
            console.log('pay', 'url', url)
            el.location.href = url
            this.next()

            // 監聽是否付款完成
            this.clearTimer()
            this.startCheckListener(order.id)
          }
        }
      } catch (e) {
        console.error('pay', 'e', e)
        alert(e.message)
        if (el) {
          el.close()
        }
      }
    },
    repay () {
      this.prev()
      this.clearTimer()
      this.pay()
    },
    finish () {
      this.tryOpenHomepage()
      this.close()
    }
  },
  async mounted () {
    this.list = await this.$store.dispatch('api/nutsbp/slide')

    try {
      this.freeCount = await this.$store.dispatch('api/ranch/deliverCount', {
        investor: _.get(this.data, 'uuid')
      })
    } catch (e) {}

    let input = this.$store.dispatch('get', {
      path: 'temp.SendBpModal.input'
    })
    let data = await this.$store.dispatch('me/cardinfo')
    if (input) {
      this.input = _.merge({}, this.input, input)
    } else {
      this.input.username = _.get(data, 'realname')
      this.input.mobile = _.get(data, 'phone')
      this.input.email = _.get(data, 'email')
      this.input.weixin = _.get(data, 'weixin')

      this.cardInfo = data
    }
  },
  watch: {
    selectedIndex (newV, oldV) {
      if (newV === null) {
        return
      }
      if (newV > -1) {
        this.input.p_name = this.list[this.selectedIndex].name || '请输入项目名称'
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "var.css";
.modal-sendbp {
  & input[type="checkbox"], & input[type="radio"] {
    transform:scale(2, 2);
  }
  & .modal-sendbp-close {
    position: absolute;
    right: -35px;
    top: -25px;
  }
  & .modal-sendbp-container {
    min-height: 300px;

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background-color: var(--colorWhite);
    height: fit-content;

    @media (--mediaPc) {
      border-radius: var(--borderRadius1);
    }
    @media (--mediaMobile) {
      border-radius: var(--borderRadius1Mobile);
    }
    & .step1-tab {
      margin-top: 59px;
      width: 100%;
      text-align: center;
      font-size: 16px;
      color: var(--color6);
      & .step1-tab-nutsbp {
        height: calc(90px - 59px);
        width: 90px;
        display: inline-block;
        cursor: pointer;
      }
      & .step1-tab-local {
        margin-left: 80px;
        height: calc(90px - 59px);
        width: 90px;
        display: inline-block;
        cursor: pointer;
      }
      & .active {
        color: var(--color4);
        border-bottom: 2px solid var(--colorMain);
      }
    }
    & .modal-sendbp-header {
      width: 400px;
      & .modal-sendbp-header-desc {
        padding: 15px;
        color: var(--colorMain);
        right: 0;
        position: absolute;
        cursor: pointer;
        & .modal-sendbp-header-desc-text {
          display: inline-block;
        }
        & .modal-sendbp-header-desc-arrow {
          display: inline-block;
          margin-left: 8px;
          width: 6px;
          height: 10px;
          background-image: url('https://az.cdn.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_arrow_explain.png');
          background-repeat: no-repeat;
        }
      }
      & .modal-sendbp-header-flow {
        padding-top: 50px;
        padding-bottom: 29px;
      }
    }
    & .modal-sendbp-body {
      width: 400px;
      text-align: center;
      & .modal-sendbp-body-step1 {
        & .modal-sendbp-body-step1-no-bg {
          height: calc(537px - 90px - 2px - 50px - calc(77px - 35px) - 110px);
          background-position: center;
          background-image: url('https://az.cdn.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_bp_illustration.png');
          background-repeat: no-repeat;
        }
        & .modal-sendbp-body-step1-no-text {
          margin-bottom: calc(77px - 35px);
          line-height:25px;
          color: var(--color5);
        }
      }
      & .modal-sendbp-body-select { /* step 1 */
        width: 340px;
        height: 295px;
        margin: 40px 30px 0 30px;

        border: 1px solid var(--colorDisabled);

        overflow-y: auto;

        @media (--mediaPc) {
          border-radius: var(--borderRadius1);
        }
        @media (--mediaMobile) {
          border-radius: var(--borderRadius1Mobile);
        }
        & .modal-sendbp-body-select-item {
          padding: 10px 0;
          margin: 0 10px;
          min-height: 50px;
          position: relative;
          & .modal-sendbp-body-select-item-img {
            position: absolute;
            left: 0;
          }
          & .modal-sendbp-body-select-item-desc {
            text-align: left;
            margin-left: calc(50px + 20px);
            & .modal-sendbp-body-select-item-desc-title {
              padding-top: 7px;
              font-weight: bold;
              @media (--mediaPc) {
                font-size: var(--textSize3);
              }
              @media (--mediaMobile) {
                font-size: var(--textSize3Mobile);
              }
            }
            & .modal-sendbp-body-select-item-desc-time {
              padding-top: 9px;
              color: var(--colorGray1);
            }
          }
          & .modal-sendbp-body-select-item-check {
            position: absolute;
            right: 40px;
            top: calc(10px + 50px / 2 - 18px / 2);
            & input {
              cursor: pointer;
            }
          }
        }
      }
      & .modal-sendbp-body-select-local {
        position: relative;
        width: 340px;
        padding: 30px 30px 0 30px;
        & .modal-sendbp-body-select-upload-btn {
          height: 28px;
          width: 62px;
          border-radius:4px;
          background-color: var(--colorMain);

          position: absolute;
          right: 30px;

          font-size: 12px;
          line-height: 28px;
          color: var(--colorWhite);
          cursor: pointer;
        }
        & .modal-sendbp-body-select-upload-area {
          height: calc(270px - 35px);
          border: 1px dashed var(--color8);

          margin-top: calc(65px - 30px);
          padding: 16px;
          overflow: auto;
          & .modal-sendbp-body-select-upload-item {
            width: 100%;
            padding-bottom: 30px;
            text-align: left;
            display: flex;
            & .left {
              width: 217px;
              display: inline-block;
              font-size: 14px;
              color: var(--color5);
            }
            & .right {
              width: calc(340px - 16px - 16px - 217px);
              display: inline-block;
              font-size: 12px;
              text-align: right;
              color: var(--color6);
            }
            & .name {
              height: 16px;
              /* ... */
              text-overflow:ellipsis;
              white-space:nowrap;
              overflow:hidden;
              display:block;
            }
            & .red {
              color: var(--color3);
            }
          }
        }
      }
      & .modal-sendbp-body-step2 {
        height: calc(600px - 59px - 110px);
        padding: 59px 30px 0 30px;
      }
      & .modal-sendbp-body-title { /* step 2 */
        font-weight: bold;
        padding-bottom: 20px;
        text-align: left;
        @media (--mediaPc) {
          font-size: var(--textSize3);
        }
        @media (--mediaMobile) {
          font-size: var(--textSize3Mobile);
        }
      }
      & .modal-sendbp-body-block { /* step 2 */
        width: 100%;eight: 36px;
        padding-bottom: 15px;
        display: flex;
        & ::placeholder {
          color: var(--color7);
          font-size: 14px;
        }
        & .modal-sendbp-body-block-title {
          position: relative;
          width: calc(340px - 260px - 5px);
          margin-left: 5px;
          display: flex;
          align-items: center;
          text-align: left;
          & .modal-sendbp-body-block-title-star {
            color: var(--colorError);
          }
        }
        & .modal-sendbp-body-block-input {
          display: inline-block;
        }
        & .modal-sendbp-body-block-textarea {
          display: inline-block;
          position: relative;
          box-sizing: border-box;
          width: 258px;
          height: 100px;
          border: 1px solid var(--colorGray4);
          padding: 12px;

          & textarea {
            resize: none;
            position: relative;
            outline: none;
            height: 100%;
            width: 100%;
            padding: 0;
            border: 0;
            @media (--mediaPc) {
              font-size: var(--textSize4);
            }
            @media (--mediaMobile) {
              font-size: var(--textSize4Mobile);
            }
          }
        }
      }
      & .modal-sendbp-body-step3 {
        padding: 59px 30px 0 30px;

        & .title {
          font-weight: bold;
          font-size: 16px;
          color: var(--color4);
          text-align: center;
          padding-bottom: 40px;
          @media (--mediaPc) {
            font-size: var(--textSize3);
          }
          @media (--mediaMobile) {
            font-size: var(--textSize3Mobile);
          }
        }
        & .q {
          position: relative;
          box-sizing: border-box;
          width: 340px;
          height: 226px;
          border: 1px solid var(--colorGray4);
          padding: 12px;

          margin-bottom: 20px;

          & textarea {
            resize: none;
            position: relative;
            outline: none;
            height: 100%;
            width: 100%;
            padding: 0;
            border: 0;
            @media (--mediaPc) {
              font-size: var(--textSize4);
            }
            @media (--mediaMobile) {
              font-size: var(--textSize4Mobile);
            }
          }
        }
        & .q-tip {
          height: 100px;
          width: 340px;
          background:rgba(248,249,252,1);
          border-radius:2px;

          box-sizing: border-box;
          padding: calc(calc(100px - 22px*4)/2) 12px;

          font-size:14px;
          text-align: left;
          line-height:22px;
          color: var(--color6);
        }
      }
      & .modal-sendbp-body-upload {
        position: relative;
        width: 340px;
        height: 65px;
        margin: 8px 30px;
        & .modal-sendbp-body-upload-files {
          text-align: left;
          width: 248px;
          height: 100%;
          border: 1px dashed var(--colorGray3);
          overflow-y: auto;

          @media (--mediaPc) {
            font-size: var(--textSize5);
            border-radius: var(--borderRadius3);
          }
          @media (--mediaMobile) {
            font-size: var(--textSize5Mobile);
            border-radius: var(--borderRadius3Mobile);
          }
          & .modal-sendbp-body-upload-files-file {
            display: inline-block;
            padding: 10px 0;
            margin: 0 15px;
          }
          & .red {
            color: var(--colorError);
          }
        }
        & .modal-sendbp-body-upload-button {
          position: absolute;
          top: 0;
          right: 0;
          padding: 0;
          width: 62px;
          @media (--mediaPc) {
            font-size: var(--textSize5);
          }
          @media (--mediaMobile) {
            font-size: var(--textSize5Mobile);
          }
        }
      }
      & .modal-sendbp-body-private {
        text-align: left;
        position: relative;
        margin: 0 30px;
        padding: 8px 0;
        & .modal-sendbp-body-private-title {
          padding-bottom: 8px;
          color: var(--colorGray0);
        }
        & .modal-sendbp-body-private-desc {
          color: var(--colorGray1);
          @media (--mediaPc) {
            font-size: var(--textSize5);
          }
          @media (--mediaMobile) {
            font-size: var(--textSize5Mobile);
          }
        }
        & .modal-sendbp-body-private-check {
          margin-top: 10px;
          position: absolute;
          right: 0;
          top: 0;
        }
      }
      & .modal-sendbp-body-tip {
        margin: 8px 30px;
        text-align: left;
        & .modal-sendbp-body-tip-title {
          padding-bottom: 8px;
          color: var(--colorGray0);
        }
        & .modal-sendbp-body-tip-desc {
          color: var(--colorGray1);
          background-color: var(--colorWhite1);
          padding: 12px;
          @media (--mediaPc) {
            font-size: var(--textSize5);
          }
          @media (--mediaMobile) {
            font-size: var(--textSize5Mobile);
          }
        }
      }
      & .modal-sendbp-body-finish {
        height: calc(300px - 110px);
        display: flex;
        align-items: center;
        justify-content: center;
        @media (--mediaPc) {
          font-size: var(--textSize3);
        }
        @media (--mediaMobile) {
          font-size: var(--textSize3Mobile);
        }
      }
      & .modal-sendbp-body-success {
        height: calc(300px - 110px);
        display: flex;
        align-items: center;
        justify-content: center;
        background-image: url('https://az.cdn.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_delivery_success.png');
        background-repeat: no-repeat;
        background-position: center;
        @media (--mediaPc) {
          font-size: var(--textSize3);
        }
        @media (--mediaMobile) {
          font-size: var(--textSize3Mobile);
        }
        & .text {
          position: absolute;
          bottom: 110px;
          font-size: 18px;
          color: var(--color5);
        }
      }
    }
    & .modal-sendbp-footer {
      width: 400px;
      text-align: center;
      & .modal-sendbp-footer-button {
        margin: 35px 20px;
        min-width: 100px;
        padding: 0 17px;

        cursor: pointer;
      }
    }

    & .modal-sendbp-desc {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;

      display: inline-block;
      width: 200px;
      color: var(--colorWhite);
      background-color: var(--colorMain);
      background-image: url('https://az.cdn.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_explain_backgound.png');

      & .modal-sendbp-desc-close {
        position: absolute;
        right: 0;
        padding: 15px;
        cursor: pointer;
        @media (--mediaPc) {
          font-size: var(--textSize5);
        }
        @media (--mediaMobile) {
          font-size: var(--textSize5Mobile);
        }
      }
      & .modal-sendbp-desc-title {
        margin: 0 23px;
        padding-top: 50px;
        @media (--mediaPc) {
          font-size: var(--textSize3);
        }
        @media (--mediaMobile) {
          font-size: var(--textSize3Mobile);
        }
      }
      & .modal-sendbp-desc-desc1 {
        margin: 0 23px;
        padding-top: 35px;
      }
      & .modal-sendbp-desc-desc2 {
        margin: 0 23px;
        padding-top: 48px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/SendBpModal.vue